import { InputMessageType } from '../../../atoms';

export const getMessage = ({
  hint,
  error,
  hasError,
}: {
  hint: string;
  error: string;
  hasError: boolean;
}) => {
  let message: string;
  let messageType: InputMessageType = 'normal';

  if (hint) {
    message = hint;
  }

  if (hasError && error) {
    message = error;
    messageType = 'error';
  }
  return {
    messageType,
    message,
  };
};
